export const Types = {
    GET_PLANT_LIST: "GET_PLANT_LIST",
    SET_PLANT_LIST: "SET_PLANT_LIST",
    ADD_PLANT: "ADD_PLANT",
    UPDATE_PLANT: "UPDATE_PLANT",
    DELETE_PLANT: "DELETE_PLANT",
    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getPlantList = (payload) => ({
    type: Types.GET_PLANT_LIST,
});

export const setPlantList = (payload) => ({
    type: Types.SET_PLANT_LIST,
    payload: payload,
});

export const addPlant = (payload) => {
    return {
        type: Types.ADD_PLANT,
        payload: payload,
    };
};

export const updatePlant = (payload) => {
    return {
        type: Types.UPDATE_PLANT,
        payload: payload,
    };
};

export const deletePlant = (payload) => {
    return {
        type: Types.DELETE_PLANT,
        payload: payload,
    };
};

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
